<app-header></app-header>

<div class="page-title-area page-title-style-two despre-bg">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a routerLink="/">Home</a></li>
                <li>Servicii pentru pacienti</li>
            </ul>
            <h2>Servicii pentru pacienti</h2>
        </div>
    </div>
</div>

<div class="about-area ptb-100">
    <div class="container">
        <div class="row">
            <div class="col-12">
                    <span class="sub-title">Accesul la medicul de familie</span>

                    <ol>
                        <li>Cererea de asigurat completata in 4 exemplare – se gaseste jos la serviciul de registratura
                            si trebuie semnata la serviciul de contabilitate al locului de munca/talonul de pensie</li>
                        <li>Cu aceste documente trebuie mers la CASA OPSNAJ din Strada Popa Savu nr. 45 , unde se va
                            inregistra oficial aceasta cerere</li>
                        <li>Reveniti in institutia noastra, cu buletinul, cardul de sanatate si cererea cu stampila
                            casei OPSNAJ, la serviciul registratura unde veti fi introdus in baza de date si va puteti
                            alege unul din medicii nostri de familie</li>
                        <li>Imediat dupa ce ati fost introdus in baza de date va puteti programa la medicul de familie
                            ales.</li>

                    </ol>

                    <span class="sub-title">Accesul la medicii specialisti</span>
                    <ol type="a">
                        <li>
                            <span>Pacientii cu medic de familie in CMDTAMP</span>
                            <ul>
                                <li>Se face pe baza unui bilet de trimitere de la medicul de familie sau alt specialist
                                    de la noi din clinica</li>
                            </ul>
                        </li>
                        <li>
                            <span>Pacientii cu medic de familie in afara CMDTAMP</span>
                            <ul>
                                <li>Pe baza unui bilet de trimitere de la medicul de familie curant/alt medic specialist
                                </li>
                                <li>Pentru programare trebuie sa va prezentati la serviciul programari unde sunteti
                                    introdus in baza de date ca si pacient</li>

                            </ul>
                        </li>
                    </ol>

                    <span class="sub-title"> Spitalizarea de ZI</span>
                    <ol type="a">
                        <li>Se face pe baza unui bilet de trimitere in urma caruia medicul specialist din incinta
                            policlinicii decide daca este cazul de spitalizare de zi sau nu, urmand sa reveniti atunci
                            cand va spune acesta pentru internare</li>
                        <li>Unele servicii pot fi contracost</li>
                    </ol>

                </div>
            </div>
        </div>
    </div>

